// extracted by mini-css-extract-plugin
export default {"container":"OpportunityDetailsPage_container__ZTw0k","header":"OpportunityDetailsPage_header__mRu9C","content":"OpportunityDetailsPage_content__B0+D+"};